module.exports = __webpack_public_path__ + "img/P150T_weapon_74.60db2b3b.png";